const calculateAdlScore = (adl) => {
  const values = Object.values(adl)
    .map(v => Number(v))              // แปลงทุกค่า
    .filter(v => !isNaN(v));          // เอาเฉพาะตัวเลขจริง

  const total = values.reduce((sum, v) => sum + v, 0);

  let group = "-";
  let color = "#eee";

  if (values.length === 0) {
    group = "-";
    color = "#eee";
  } else if (total >= 12) {
    group = "ติดสังคม";
    color = "#E8F5E9"; // เขียว
  } else if (total >= 5) {
    group = "ติดบ้าน";
    color = "#FFFDE7"; // เหลือง
  } else {
    group = "ติดเตียง";
    color = "#FDECEA"; // แดง
  }

  return { total, group, color };
};


export{
    calculateAdlScore
}